const certProdListRefinerColumns = [
  { Id: 'certificateStatus', Value: 'Certificate Status' },
  { Id: 'modelName', Value: 'Model Name' },
  { Id: 'status', Value: 'Model Status' },
  { Id: 'ownerName', Value: 'Applicant/Owner Name' },
  { Id: 'projectNumber', Value: 'Project Number' },
  { Id: 'collectionName', Value: 'Collection Name' },
  { Id: 'collectionStatus', Value: 'Collection Status' },
  { Id: 'modelNomenclature', Value: 'Model Nomenclature' },
  { Id: 'productType', Value: 'Product Type' },
  { Id: 'referenceNumber', Value: 'Reference Number (ex. File Number)' },
  { Id: 'familySeries', Value: 'Family/Series' },
  { Id: 'creationDate', Value: 'Creation Date' },
]

export default certProdListRefinerColumns
